import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthly", "yearly", "button"]

  select(event) {
    const yearly = event.currentTarget.dataset.period === "yearly"

    this.buttonTargets.forEach((button) => {
      button.classList.toggle("active", button === event.currentTarget)
    })
    this.monthlyTargets.forEach((element) => { element.hidden = yearly })
    this.yearlyTargets.forEach((element) => { element.hidden = !yearly })
  }
}
